<script setup>
import * as AdaptiveCards from 'adaptivecards'
import * as ACData from 'adaptivecards-templating'
import Emitter from '@/emit.js'
import { ref, onMounted } from 'vue'
import { useWidget } from '@/widget'
import { replaceUrl } from '@/helpers'
const props = defineProps({
  product: Object,
  template: String
})

// const adaptiveCard = ref(null)
const cardContiner = ref(null)
const { config } = useWidget()
onMounted(() => {
  const temp = {
    $schema: 'http://adaptivecards.io/schemas/adaptive-card.json',
    type: 'AdaptiveCard',
    version: '1.6',
    fallbackText: 'Karta produktowa pokazująca produkt ze sklepu',
    body: [
      {
        type: 'TextBlock',
        text: '${attributes.name}',
        weight: 'Bolder',
        spacing: 'None',
        wrap: true,
        style: 'heading'
      },
      {
        type: 'ColumnSet',
        columns: [
          {
            type: 'Column',
            width: 2,
            items: [
              {
                type: 'TextBlock',
                text: '${attributes.second_line}',
                isSubtle: true,
                spacing: 'None',
                wrap: true
              },
              {
                type: 'TextBlock',
                text: '${attributes.description}',
                size: 'Small',
                wrap: true,
                maxLines: 6,
                spacing: 'Small'
              }
            ]
          },
          {
            type: 'Column',
            width: 1,
            horizontalAlignment: 'Right',
            verticalContentAlignment: 'Center',
            items: [
              {
                type: 'Image',
                url: '${attributes.thumbnail_url}',
                altText: '${attributes.title}'
              }
            ]
          }
        ]
      },
      {
        type: 'TextBlock',
        text: '${attributes.price}',
        wrap: true,
        horizontalAlignment: 'Right',
        style: 'heading',
        fontType: 'Monospace',
        id: 'price'
      }
    ],
    actions: [
      {
        type: 'Action.OpenUrl',
        title: 'Zobacz',
        url: '${url}',
        role: 'Link',
        tooltip: 'Kliknij aby obejrzeć produkt'
      },
      {
        type: 'Action.Submit',
        title: 'Do koszyka',
        tooltip: 'Cart',
        role: '',
        data: {
          quantity: 1,
          action: 'add_to_cart',
          size: 'uniw',
          product: '{product}'
        }
      }
    ]
  }
  const fromApi = config?.adaptiveCard?.[props.template]
  const template = new ACData.Template(fromApi ? fromApi : temp)
  const card = new AdaptiveCards.AdaptiveCard()
  const product = props.product

  const price = getPrice(product)
  product.attributes.price = price
  card.parse(template.expand({ $root: props.product }))
  const renderedCard = card.render()
  card.onExecuteAction = (action) => {
    if (action instanceof AdaptiveCards.OpenUrlAction) {
      window.top.location.href = replaceUrl(action.url)
    } else if (action instanceof AdaptiveCards.SubmitAction) {
      const data = {
        ...action.toJSON(),
        data: action._processedData
      }
      Emitter.emit('adaptiveCardAction', { ...data, product })
    }
  }
  cardContiner.value.appendChild(renderedCard)
})
const getPrice = (product) => {
  if (!product || !product.attributes || !product.attributes.price) return ''
  let price = product.attributes.price
  if (typeof product.attributes.price === 'string') {
    price = parseFloat(product.attributes.price.replace(',', '.'))
  }
  return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN' }).format(price)
}
</script>

<template>
  <div class="max-w-[500px]" ref="cardContiner"></div>
</template>
